import { PropsWithChildren, ReactNode } from 'react';
import {
	PageHeaderTitleContainer,
	PageHeaderActions,
	PageHeaderContainer,
	PageTitle,
} from 'shared/_components/page/styles';

type PageHeaderProps = PropsWithChildren<{
	breadcrumbs?: ReactNode[];
	actions?: ReactNode;
}>;

export default function PageHeader(props: PageHeaderProps) {
	const { children, breadcrumbs = [], actions } = props;

	return (
		<PageHeaderContainer>
			<PageHeaderTitleContainer>
				{breadcrumbs?.map((bc) => (<>{bc}{' » '}</>)) || null}
				<PageTitle>{children}</PageTitle>
			</PageHeaderTitleContainer>
			{!!actions && (
				<PageHeaderActions>
					{actions}
				</PageHeaderActions>
			)}
		</PageHeaderContainer>
	);
}
